import { Component, OnInit, OnDestroy } from '@angular/core';
import { SignInFacade, SignInState } from './sign-in.facade';
import { Subscription } from 'rxjs';
import { COMMON_IMPORTS } from '../../global-misc/common-imports';
import { ResetPasswordDialogComponent } from './reset-password-dialog/reset-password-dialog.component';
import { GlobalLangChooserComponent } from '../../global-components/global-lang-chooser/global-lang-chooser.component';
import { DialogModule } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-sign-in',
  imports: [...COMMON_IMPORTS, ResetPasswordDialogComponent, GlobalLangChooserComponent, DialogModule, FormsModule],
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css'],
})
export class SignInComponent implements OnInit, OnDestroy {
  state: SignInState = 'idle';
  form = this.facade.form;
  private sub = new Subscription();
  passwordVisible = false;
  submitted = false; // Track if form has been submitted
  showResetDialog = false;
  show2FADialog = false;
  twoFactorCode = '';

  constructor(private facade: SignInFacade) {}

  ngOnInit(): void {
    this.sub.add(
      this.facade.state$.subscribe((state) => {
        this.state = state;
      }),
    );

    //Extract query params and url decode
    const urlParams = new URLSearchParams(window.location.search);
    let emailParam = urlParams.get('email');
    const inviteTokenParam = urlParams.get('inviteToken');

    if (emailParam) {
      emailParam = decodeURIComponent(emailParam);
    }

    this.facade.start(emailParam, inviteTokenParam);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  async onSubmit() {
    const resp = await this.facade.start2FA();

    if (resp === false) {
      return;
    }

    this.submitted = true; // Set submitted to true on submit
    this.show2FADialog = true;
  }

  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }

  onForgotPassword() {
    if (this.facade.canOpenUpLostPasswordDialog()) {
      this.showResetDialog = true;
    }
  }

  onResetPasswordConfirm() {
    this.facade.sendPasswordResetEmail();
  }

  check2faCode() {
    if (!this.twoFactorCode) {
      return;
    }

    this.facade.check2FA(this.twoFactorCode);
  }
}
